import { Link } from 'react-router-dom';
import { useCountUp } from '@/hooks/useScrollReveal';

export default function TransportHero() {
  const { count: vehicleCount, countRef } = useCountUp(2500, 2000, true);
  const { count: routeCount, countRef: routeRef } = useCountUp(180, 2000, true);

  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-br from-secondary-800 via-secondary-700 to-brand-700">
      <div className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.3'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-secondary-800/70"></div>

      <div className="absolute right-0 top-0 w-1/2 h-full hidden lg:block">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-secondary-800/30 to-secondary-700/80"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20reefer%20refrigerated%20truck%20on%20highway%20at%20blue%20hour%2C%20industrial%20cold%20chain%20logistics%2C%20clean%20corporate%20photography%20style%2C%20dramatic%20lighting%20on%20vehicle%2C%20cool%20blue-white%20color%20grading%2C%20no%20driver%20visible&width=900&height=800&seq=freshhlock-transport-hero&orientation=portrait"
          alt="Reefer truck on highway"
          className="w-full h-full object-cover opacity-20"
        />
      </div>

      <div className="container-page relative z-10">
        <div className="flex flex-col lg:flex-row items-center min-h-[500px] md:min-h-[560px] py-16 md:py-20">
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-600/40 border border-secondary-400/30 mb-6">
              <div className="w-2 h-2 rounded-full bg-secondary-300"></div>
              <span className="text-xs font-medium text-secondary-200 uppercase tracking-widest">
                Freshhlock Transport
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-5xl font-bold text-paper-50 leading-tight mb-6 text-balance">
              Your Van Has Space. Someone&apos;s Harvest Needs It.
            </h1>
            <p className="text-base md:text-lg text-secondary-100/80 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              Lease spare capacity in your refrigerated vehicle, or book verified cold-chain transport for your produce — all on one platform.
            </p>

            <div className="flex flex-wrap items-center gap-8 justify-center lg:justify-start">
              <div className="text-center">
                <div ref={countRef} className="font-heading text-3xl font-bold text-secondary-300 tabular-nums">
                  {vehicleCount.toLocaleString()}+
                </div>
                <div className="text-xs text-secondary-200/70 mt-1">Vehicles Registered</div>
              </div>
              <div className="text-center">
                <div ref={routeRef} className="font-heading text-3xl font-bold text-accent-400 tabular-nums">
                  {routeCount.toLocaleString()}+
                </div>
                <div className="text-xs text-secondary-200/70 mt-1">Active Routes</div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/contact"
                className="px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Register Your Vehicle
              </Link>
              <Link
                to="/contact"
                className="px-8 py-3.5 border-2 border-paper-300/30 hover:border-paper-50/50 text-paper-50 font-semibold text-sm rounded-lg transition-all hover:bg-paper-50/5 whitespace-nowrap cursor-pointer"
              >
                Book Cold-Chain Transport
              </Link>
            </div>
          </div>
          <div className="hidden lg:block w-2/5"></div>
        </div>
      </div>
    </section>
  );
}